import { render, staticRenderFns } from "./TemplateMessageAdd.vue?vue&type=template&id=042701a0&"
import script from "./TemplateMessageAdd.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports